export const UNKNOWN = 'UNKNOWN';
export const METHOD_MUST_BE_OVERLOADED = 'METHOD_MUST_BE_OVERLOADED';
export const NO_PLAYER = 'NO_PLAYER';

export const NO_CONTAINER = 'NO_CONTAINER';
export const NO_SOURCE = 'NO_SOURCE';

export const ENGINE_ABORTED = 'ENGINE_ABORTED_ERROR';
export const ENGINE_NETWORK = 'ENGINE_NETWORK_ERROR';
export const ENGINE_DECODE = 'ENGINE_DECODE_ERROR';
export const ENGINE_SRC_NOT_SUPPORTED = 'ENGINE_SRC_NOT_SUPPORTED_ERROR';
export const ENGINE_UNKNOWN = 'ENGINE_UNKNOWN';

export const AUTOPLAY_PREVENTED_ERROR = 'AUTOPLAY_PREVENTED_ERROR';

export const DASH_CAPABILITY_ERROR = 'DASH_CAPABILITY_ERROR';
export const DASH_DOWNLOAD_ERROR = 'DASH_DOWNLOAD_ERROR';
export const DASH_MANIFEST_ERROR = 'DASH_MANIFEST_ERROR';
export const DASH_MEDIA_SOURCE_ERROR = 'DASH_MEDIA_SOURCE_ERROR';
export const DASH_KEY_SESSION_ERROR = 'DASH_KEY_SESSION_ERROR';
export const DASH_KEY_MESSAGE_ERROR = 'DASH_KEY_MESSAGE_ERROR';
export const DASH_TIMED_TEXT_ERROR = 'DASH_TIMED_TEXT_ERROR';

export const DASH_OTHER_ERROR = 'DASH_OTHER_ERROR';
